import "core-js/modules/es6.array.find";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 引入全局实例
import _CodeMirror from 'codemirror'; // 核心样式

import 'codemirror/lib/codemirror.css'; // 引入主题后还需要在 options 中指定主题才会生效 darcula  gruvbox-dark hopscotch  monokai

import 'codemirror/theme/panda-syntax.css'; //提示css

import "codemirror/addon/hint/show-hint.css"; // 需要引入具体的语法高亮库才会有对应的语法高亮效果
// codemirror 官方其实支持通过 /addon/mode/loadmode.js 和 /mode/meta.js 来实现动态加载对应语法高亮库
// 但 vue 貌似没有无法在实例初始化后再动态加载对应 JS ，所以此处才把对应的 JS 提前引入

import 'codemirror/mode/javascript/javascript.js';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/xml/xml.js';
import 'codemirror/mode/clike/clike.js';
import 'codemirror/mode/markdown/markdown.js';
import 'codemirror/mode/python/python.js';
import 'codemirror/mode/r/r.js';
import 'codemirror/mode/shell/shell.js';
import 'codemirror/mode/sql/sql.js';
import 'codemirror/mode/swift/swift.js';
import 'codemirror/mode/vue/vue.js'; // 尝试获取全局实例

var CodeMirror = window.CodeMirror || _CodeMirror;
export default {
  name: 'JCodeEditor',
  props: {
    // 外部传入的内容，用于实现双向绑定
    value: {
      type: String,
      default: ''
    },
    // 外部传入的语法类型
    language: {
      type: String,
      default: null
    },
    languageChange: {
      type: Boolean,
      default: false,
      required: false
    },
    placeholder: {
      type: String,
      default: null
    },
    // 显示行号
    lineNumbers: {
      type: Boolean,
      default: true
    },
    // 是否显示全屏按钮
    fullScreen: {
      type: Boolean,
      default: false
    },
    // 全屏以后的z-index
    zIndex: {
      type: [Number, String],
      default: 999
    }
  },
  data: function data() {
    return {
      // 内部真实的内容
      code: '',
      hasCode: false,
      // 默认的语法类型
      mode: 'javascript',
      // 编辑器实例
      coder: null,
      // 默认配置
      options: {
        // 缩进格式
        tabSize: 2,
        // 主题，对应主题库 JS 需要提前引入
        theme: 'panda-syntax',
        line: true,
        // extraKeys: {'Ctrl': 'autocomplete'},//自定义快捷键
        hintOptions: {
          tables: {
            users: ['name', 'score', 'birthDate'],
            countries: ['name', 'population', 'size']
          }
        }
      },
      // 支持切换的语法高亮类型，对应 JS 已经提前引入
      // 使用的是 MIME-TYPE ，不过作为前缀的 text/ 在后面指定时写死了
      modes: [{
        value: 'css',
        label: 'CSS'
      }, {
        value: 'javascript',
        label: 'Javascript'
      }, {
        value: 'html',
        label: 'XML/HTML'
      }, {
        value: 'x-java',
        label: 'Java'
      }, {
        value: 'x-objectivec',
        label: 'Objective-C'
      }, {
        value: 'x-python',
        label: 'Python'
      }, {
        value: 'x-rsrc',
        label: 'R'
      }, {
        value: 'x-sh',
        label: 'Shell'
      }, {
        value: 'x-sql',
        label: 'SQL'
      }, {
        value: 'x-swift',
        label: 'Swift'
      }, {
        value: 'x-vue',
        label: 'Vue'
      }, {
        value: 'markdown',
        label: 'Markdown'
      }],
      // code 编辑器 是否全屏
      fullCoder: false
    };
  },
  watch: {
    // value: {
    //   immediate: false,
    //   handler(value) {
    //     this._getCoder().then(() => {
    //       this.coder.setValue(value)
    //     })
    //   }
    // },
    language: {
      immediate: true,
      handler: function handler(language) {
        var _this2 = this;

        this._getCoder().then(function () {
          // 尝试从父容器获取语法类型
          if (language) {
            // 获取具体的语法类型对象
            var modeObj = _this2._getLanguage(language); // 判断父容器传入的语法是否被支持


            if (modeObj) {
              _this2.mode = modeObj.label;

              _this2.coder.setOption('mode', "text/".concat(modeObj.value));
            }
          }
        });
      }
    }
  },
  computed: {
    placeholderShow: function placeholderShow() {
      if (this.placeholder == null) {
        return "\u8BF7\u5728\u6B64\u8F93\u5165".concat(this.language, "\u4EE3\u7801");
      } else {
        return this.placeholder;
      }
    },
    nullTipStyle: function nullTipStyle() {
      if (this.lineNumbers) {
        return {
          left: '36px'
        };
      } else {
        return {
          left: '12px'
        };
      }
    },
    // coder 配置
    coderOptions: function coderOptions() {
      return {
        tabSize: this.options.tabSize,
        theme: this.options.theme,
        lineNumbers: this.lineNumbers,
        line: true,
        hintOptions: this.options.hintOptions
      };
    },
    fullScreenParentProps: function fullScreenParentProps() {
      var props = {
        class: ['full-screen-parent', this.fullCoder ? 'full-screen' : ''],
        style: {}
      };

      if (this.fullCoder) {
        props.style['z-index'] = this.zIndex;
      }

      return props;
    }
  },
  mounted: function mounted() {
    // 初始化
    this._initialize();
  },
  methods: {
    // 初始化
    _initialize: function _initialize() {
      var _this3 = this;

      // 初始化编辑器实例，传入需要被实例化的文本域对象和默认配置
      this.coder = CodeMirror.fromTextArea(this.$refs.textarea, this.coderOptions); // 编辑器赋值

      this.coder.setValue(this.value || this.code);

      if (this.value || this.code) {
        this.hasCode = true;
      } else {
        this.hasCode = false;
      } // 支持双向绑定


      this.coder.on('change', function (coder) {
        _this3.code = coder.getValue();

        if (_this3.code) {
          _this3.hasCode = true;
        } else {
          _this3.hasCode = false;
        }

        if (_this3.$emit) {
          _this3.$emit('input', _this3.code);
        }
      });
      this.coder.on('focus', function () {
        _this3.hasCode = true;
      });
      this.coder.on('blur', function () {
        if (_this3.code) {
          _this3.hasCode = true;
        } else {
          _this3.hasCode = false;
        }
      });
      /* this.coder.on('cursorActivity',()=>{
         this.coder.showHint()
       })*/
    },
    getCodeContent: function getCodeContent() {
      return this.code;
    },
    setCodeContent: function setCodeContent(val) {
      this.coder.setValue(val);
    },
    // 获取当前语法类型
    _getLanguage: function _getLanguage(language) {
      // 在支持的语法类型列表中寻找传入的语法类型
      return this.modes.find(function (mode) {
        // 所有的值都忽略大小写，方便比较
        var currentLanguage = language.toLowerCase();
        var currentLabel = mode.label.toLowerCase();
        var currentValue = mode.value.toLowerCase(); // 由于真实值可能不规范，例如 java 的真实值是 x-java ，所以讲 value 和 label 同时和传入语法进行比较

        return currentLabel === currentLanguage || currentValue === currentLanguage;
      });
    },
    _getCoder: function _getCoder() {
      var _this = this;

      return new Promise(function (resolve) {
        (function get() {
          if (_this.coder) {
            resolve(_this.coder);
          } else {
            setTimeout(get, 10);
          }
        })();
      });
    },
    // 更改模式
    changeMode: function changeMode(val) {
      // 修改编辑器的语法配置
      this.coder.setOption('mode', "text/".concat(val)); // 获取修改后的语法

      var label = this._getLanguage(val).label.toLowerCase(); // 允许父容器通过以下函数监听当前的语法值


      this.$emit('language-change', label);
    },
    nullTipClick: function nullTipClick() {
      this.coder.focus();
    }
  }
};